meedy.controller('meedy.helpMoviesController', ['$rootScope', '$scope', '$state', '$stateParams', '$translate', '$mdDialog',
    'meedyConfig', 'meedy.objectHelper', 'meedy.baseModel', 'meedy.applicationModel',
    function ($rootScope, $scope, $state, $stateParams, $translate, $mdDialog, config, objectHelper, baseModel, applicationModel) {

        var listeners = {};

        function setData() {

        }

        function setPermissions() {
        }

        function setListeners() {
        }

        function setActions() {
            
        }

        function configureInterface() {

        }

        function initialize() {
            applicationModel.fillViewportMode = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
